import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=4e5f166d&scoped=true"
import script from "./EditEvent.vue?vue&type=script&lang=js"
export * from "./EditEvent.vue?vue&type=script&lang=js"
import style0 from "./EditEvent.vue?vue&type=style&index=0&id=4e5f166d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f166d",
  null
  
)

export default component.exports